define('ViewManager',[
    'evertrue',
    'jquery',
    'underscore',
    'backbone'
], function ( EverTrue, $, _, Backbone) {

    // constructor
    var ViewManager = function(options) {
        this.initialize.apply(this, arguments);
    };

    _.extend( ViewManager.prototype, {
        // viewstack to hold all active views
        views: [],
        _byURL: {},
        _byCid: {},
        namespace : null,

        initialize: function() {
            // get the container for this ViewManager
            this.$container = this.$el || EverTrue.$el;
        },

        isViewCached: function(view, options) {
            var url = (options && options.url) || view.url;
            if (url) {
                var cached = this.getByURl(url);
                if (cached) return cached;
            }
            return false;
        },

        // adds the view to the view stack and
        register: function(view, options, change, callback) {
            // if we are not passing in an instantiated view, assume we are passing in the file name of the view
            var that = this;
            if (typeof(view) === "string") {
            // if(!(view instanceof Backbone.View)){
                that.loadAsync( view, function ViewManagerLoadAsync ( newView ) {
                    var nV,
                        cachedV = that.isViewCached(view, options);
                    if (cachedV){
                        nV = cachedV;
                    } else {
                        nV = new newView(options);
                        that.add(nV);
                    }
                    that.register( nV, options, change, callback );
                });
            } else {

                if(change !== false){
                    this.showPage(view);
                    EverTrue.vent.trigger('navChange');
                }
                if ( _.isFunction(callback) ) {
                    callback(view);
                }
            }
        },

        loadAsync: function(viewName, callback) {
            // right now we only support one requireJS dependency (the view file)
            require(['views/'+viewName], function ( View ) {
                callback( View );
            });
        },

        setCssNamespace: function(page) {
            var page_namespace = ""
            if (page && page.namespace) {
                page_namespace = page.namespace
            }
            this.$container.attr('data-page', page_namespace);
        },

        ensureMinHeightIsViewPort: function() {
            var viewHeight = $(window).height();
            this.$container.css('min-height', viewHeight);
        },

        isBasePage: function(page) {
            if (page.url && page.url === '/feed') return true;
            return false;
        },

        showPage: function(page) {
            var that = this;
            // remove old page and set new page as the current page
            this.setCssNamespace(page);

            if (this.currentPage) {
                this.destroy(this.currentPage);
            }

            // Remove body contents if on health check page
            if (page.url == "health") {
                $("body").html(page.$el);
            } else if (page.$el) {
                that.ensureMinHeightIsViewPort();
                this.currentPage = page;
                page.$el.addClass('page');

                // hack to get page plugins working without overwriting the page we already made after we rendered with node. So instead of keeping backbone silent and not triggering the route, I am triggering the route but not appending the view. Works for the landing page views but definatley needs to be rethought
                if (!window.silent || (window.silent && window.isNode)){
                    this.$container.append(page.$el);
                    window.silent = false; // want to do things normally after the first pass
                }
            }

            this.doScroll();
        },

        doScroll: function() {
            // for now just ensure we always scroll to the top of the
            // page during transitions
            $(window).scrollTop(0);
        },

        add: function(view) {
            // associate a url with this view
            view.url = Backbone.history.fragment;
            // add to viewstack
            this.views.push( view );
            // add to byURL view hash
            this._byURL[view.url] = view;
            // add to byCid view hash
            this._byCid[view.cid] = view;
        },

        clear: function() {
            this.rendered = false;
            if (EverTrue.NavigationView) {
                EverTrue.NavigationView.destroy();
                delete EverTrue.NavigationView;
            }
        },

        getByURl: function(url) {
            return this._byURL[url];
        },

        destroyCurrentView: function() {
            if (this.currentPage) {
                this.destroy(this.currentPage);
            }
        },

        destroy: function(view) {
            // kill view and unbind all its references
            view.destroy();
            this.rendered = false;
            var viewStack = this.views;
            // remove view from the view stack
                var viewToRemove = _.each(this.views, function(v, i, l){
                    if (!v) {
                        return;
                    }
                    if (v.cid === view.cid) {
                        return viewStack.splice(i,1);
                    }
                });
            // remove it's refrences
            delete this._byURL[view.url];
            delete this._byCid[view.cid];
        },

        // reset the viewstack
        reset: function() {
            this.views = [];
            this._byURL = {};
            this._byCid = {};
        }

    });

    return ViewManager;
});

